<template lang="pug">
pr-wrapper.messages.animated(fs, bg, bgo=".5", :zi="index", nv-sleep-protect, v-visible="activated")
  pr-wrapper.messages-container.animated.d-flex.flex-column.justify-content-center(fs, bg, zi="1", :class="position")
    message-detail(:message="selected", v-visible="selected", @close-detail="closeDetail")
    .messages-header.border-bottom.px-5.py-4.shadow(ref="header")
      pr-subtitle {{ $t('Messages') }}
      pr-text.mt-2(:class="{ 'text-muted': !newMessages.length }") {{ $tc('You have no new messages.', newMessages.length) }}
    .messages-scope.overflow-hidden(v-nv:scope="'messages'", data-scroll="center", nv-exit-protect, @nv-exit="close", @nv-back="close", ref="scope")
      .d-flex.py-5(v-if="!messages.length")
        pr-button.themed(v-nv, @nv-enter="close") {{ $t('Close') }}
      .scroll-container.animated.position-relative.px-5.pt-5(ref="body")
        .row.message-item.animated.bordered.no-gutters.border.mb-4(v-for="message in messages", v-nv, :key="message.id", @nv-enter="select(message)")
          .col.d-flex.align-items-center.justify-content-center.border-right
            icon.animated(
              :icon="message.readed ? 'envelope-open' : 'envelope'",
              :class="{ fas: !message.readed, textMuted: !message.readed, colored: !message.readed }"
            )
          .col.col-11.p-3
            .message-info.d-flex.mb-2
              .text-muted.flex-grow-1 {{ `${$t('From')}: ${message.from}` }}
              moment.small.text-muted.font-weight-bold.pl-2(humanize, format="date", :value="message.date", live)
            pr-text.content(ellipsis) {{ `${message.text}` | lineBreaks }}

    .messages-footer.p-3(ref="footer")
</template>

<script>
import { mapGetters, mapState } from "vuex"
import messageDetail from "./message-detail"

import services from "@/services/service"

export default {
  name: "messages",
  components: {
    messageDetail
  },
  filters: {
    lineBreaks: function(value) {
      if (!value) return ""
      value = value.toString()
      return value.replace(/\r?\n|\r|<br>|<br \/>/g, " ")
    }
  },
  data() {
    return {
      pool: [],
      selected: null,
      activated: false,
      payload: {},
      lastNavigation: null,
      index: "0"
    }
  },
  computed: {
    position() {
      return {
        //left: this.payload.options.position === "left",
        right: true,
        activated: this.activated
      }
    },
    ...mapState("services", ["messages"]),
    ...mapGetters("services", ["newMessages"])
  },
  watch: {
    activated(nval) {
      this.$emit("activate", { name: this.$options.name, state: nval })
      this.index = nval ? "101" : "0"
    }
  },
  mounted() {
    _$.vue.$on("messages", this.activate)
    _$.vue.$on("beforeRoute", () => this.close("abort"))
  },
  methods: {
    async activate(payload) {
      if (!payload) return this.close("abort")
      else if (payload === "skip") return this.close(payload)

      if (!this.validatePayload(payload)) return false
      if (this.payload.id && payload.id && this.payload.id !== payload.id && this.pool.indexOf(payload.id) < 0) return this.pool.push(payload.id)
      if (this.activated) this.payload.reject()

      this.payload = payload

      await this.$nextTick()

      this.lastNavigation = this.lastNavigation || { current: _$.nav.getCurrentScope(), prev: _$.nav.getPrevScope() }

      if (this.$refs.header.offsetHeight + this.$refs.body.offsetHeight + this.$refs.footer.offsetHeight > window.innerHeight)
        this.$refs.scope.style.maxHeight = window.innerHeight - this.$refs.header.offsetHeight - this.$refs.footer.offsetHeight + "px"
      else this.$refs.scope.style.maxHeight = "none"

      await _$.nav.sync("messages", true)
      await _$.sleep(200)
      this.activated = true

      let message = null
      if (this.payload.id) message = this.messages.find(message => message.id == this.payload.id)
      if (message) this.select(message)
    },
    validatePayload(payload) {
      if (typeof payload !== "object") return false
      if (!payload.resolve || !payload.reject) return false
      if (typeof payload.resolve !== "function") return false
      if (typeof payload.reject !== "function") return false

      return true
    },
    select(message) {
      message.readed = true
      services.action.saveMessages()
      this.selected = message
      this.$nextTick(() => _$.nav.changeScope("message-detail"))
    },
    closeDetail() {
      this.selected = null
      this.payload.id = null

      if (this.pool.length) {
        const message = this.pool.pop()
        this.$messages(message)
        return true
      }

      this.$nextTick(() => _$.nav.changeScope("messages"))
    },
    close(reason, resolve) {
      if (!this.activated) return false

      if (this.lastNavigation && reason !== "abort") {
        if (this.lastNavigation.current) _$.nav.changeScope(this.lastNavigation.current.name)
        _$.nav._prevScope = this.lastNavigation.prev
      }

      this.lastNavigation = null
      this.activated = false

      if (this.selected && reason === "skip") {
        this.selected.readed = false
        services.action.saveMessages()
      }
      this.selected = null

      if (resolve) return this.payload.resolve(resolve)
      else return this.payload.reject()
    }
  }
}
</script>

<style lang="scss" scoped>
.messages-container {
  width: 50%;
  box-shadow: 10px 0px 15px 2px rgba(0, 0, 0, 0.5);

  &.left {
    left: -55%;
    right: auto !important;
    &.activated {
      left: 0;
    }
  }

  &.right {
    box-shadow: -10px 0px 15px 2px rgba(0, 0, 0, 0.5);
    right: -55%;
    left: auto !important;
    &.activated {
      right: 0;
    }
  }

  .messages-header {
    position: relative;
    z-index: 1;
  }
  .messages-scope {
    max-height: 0;

    .message-item {
      border-width: 2px !important;

      .content {
        font-size: 1.1em;
      }
    }
  }
}
</style>
